var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfobulleAide2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32zM27.6 17.326c0.8 0.8 1.6 1.199 2.8 1.199s2.801-0.399 3.601-1.199c0.8-0.8 1.2-1.999 1.2-3.199s-0.4-2.001-1.2-2.801c-0.8-0.8-2-1.199-3.2-1.199s-2.4 0.399-3.2 1.199c-0.8 0.8-1.2 1.999-1.2 3.199s0.4 2.001 1.2 2.801zM24 27.326l3.6 0.801h0.4v20.799l-3.601 0.4v3.199h14.4v-3.199l-3.599-0.4v-25.199l-1.601-1.201-9.6 1.201v3.6z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobulleAide2);
export default __webpack_public_path__ + "static/media/infobulle-aide-2.5049a5540f396d4e52114eaa7c71b9ab.svg";
export { ForwardRef as ReactComponent };